export type VaultFilter = "all" | "note" | "tool" | "read";

const FILTERS: { value: VaultFilter; label: string }[] = [
  { value: "all", label: "Everything" },
  { value: "note", label: "My notes" },
  { value: "tool", label: "Tools" },
  { value: "read", label: "Reads" },
];

export function FilterBar({
  active,
  onChange,
}: {
  active: VaultFilter;
  onChange: (f: VaultFilter) => void;
}) {
  return (
    <div className="filters" role="group" aria-label="Filter vault by type">
      <span className="marker" aria-hidden="true">
        sort by —
      </span>
      {FILTERS.map((f) => (
        <button
          key={f.value}
          type="button"
          className="filter-btn"
          data-filter={f.value}
          aria-pressed={active === f.value}
          onClick={() => onChange(f.value)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
